import { ChevronRight } from "lucide-react";
import { useId, useState } from "react";
import type { ReactNode } from "react";
import { cn } from "@/core/utils/utils";

interface CollapsibleSectionProps {
  label: string;
  children: ReactNode;
}

export const CollapsibleSection = ({
  label,
  children,
}: CollapsibleSectionProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const contentId = useId();
  const buttonId = `${contentId}-button`;

  return (
    <div className="mt-2">
      <button
        id={buttonId}
        type="button"
        aria-controls={contentId}
        aria-expanded={isExpanded}
        onClick={() => setIsExpanded((prev) => !prev)}
        className="flex items-center gap-1 text-sm text-tertiary-text transition-colors hover:text-secondary-text"
      >
        <ChevronRight
          className={cn("h-3 w-3 transition-transform", {
            "rotate-90": isExpanded,
          })}
        />
        {label}
      </button>
      {isExpanded && (
        <div
          id={contentId}
          role="region"
          aria-labelledby={buttonId}
          className="mt-2 border-l border-stroke-tertiary pl-3"
        >
          {children}
        </div>
      )}
    </div>
  );
};
